import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Route, Router, Routes } from "react-router-dom";
import Layout from "./component/Layout";
import Dashboard from "./Pages/Dashboard";
import Booking from "./Pages/Booking";
import Transaction from "./Pages/Transaction";
import Config from "./Pages/Config";

import { Toaster } from "react-hot-toast";
import Table from "./component/Table";
import SystemConfig from "./component/SystemConfig";
import FieldsDetail from "./component/FieldsDetail";
import ProtectedRoute from "./component/ProtectedRoute";
import Login from "./component/Login";

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login/>} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="table" element={<Table />} />
            <Route path="booking" element={<Booking />} />
            <Route path="transaction" element={<Transaction />} />
            <Route path="config" element={<Config />} />
            <Route path="config/events" element={<Table />} />
            <Route path="systemConfig" element={<SystemConfig />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        containerStyle={{ top: 10 }}
        toastOptions={{
          className: "",
          style: {
            background: "#575555",
            color: "white",
          },
        }}
      />
    </div>
  );
}

export default App;
